import { type ShortcutDataWithRef, type ShortcutCallback } from "./models";

class ShortcutEvents {
  #missedMessagesQueue: ShortcutDataWithRef[] = [];

  #listeners: ShortcutCallback[] = [];

  public listen = (callback: ShortcutCallback) => {
    this.#listeners.push(callback);

    // This is the first listener, so we process all the events that were sent until now
    if (this.#listeners.length === 1 && this.#missedMessagesQueue.length > 0) {
      this.#missedMessagesQueue.forEach(missedMessage => { callback(missedMessage); });
      this.#missedMessagesQueue = [];
    }

    return () => {
      this.#listeners = this.#listeners.filter(x => x !== callback);
    };
  };

  public updateShortcut = (data: ShortcutDataWithRef) => {
    // If there are no listeners, we queue the message until we get the first listener
    if (this.#listeners.length === 0) {
      this.#missedMessagesQueue.push(data);
    } else {
      this.#listeners.forEach(l => { l(data); });
    }
  };
}

export const shortcutEvents = new ShortcutEvents();